import type { RichEditMode, RichEditPolicy, RichEditPublicVariant } from './RichEditTypes'

export const ALL_PUBLIC_RICH_EDIT_MODES = [
  'plain',
  'std',
  'extended',
  'blocks',
  'canvas',
] as const satisfies readonly RichEditMode[]

export function defineRichEditPolicy(
  enabledModes: readonly RichEditMode[],
  defaultMode: RichEditMode,
): RichEditPolicy {
  const uniqueModes = [...new Set(enabledModes)]
  if (!uniqueModes.length) throw new Error('RichEdit policy requires at least one enabled mode')
  if (!uniqueModes.includes(defaultMode)) {
    throw new Error(`RichEdit policy default "${defaultMode}" is not enabled`)
  }
  return {
    enabledModes: uniqueModes,
    defaultMode,
  }
}

export function experimentalRichEditPolicy(
  defaultMode: RichEditMode,
): RichEditPolicy {
  return defineRichEditPolicy(ALL_PUBLIC_RICH_EDIT_MODES, defaultMode)
}

export function fixedRichEditPolicy(
  variant: RichEditPublicVariant,
  includePlain = true,
): RichEditPolicy {
  return defineRichEditPolicy(includePlain ? ['plain', variant] : [variant], variant)
}
